import { reactive, ref } from "vue";
import { apiCommonInfo, apiCommonUpdateInfo } from "@/request/api";
import { isChineseLetterNumber } from "@/utils/validate";
import { ElMessage } from "element-plus";

export default () => {
    const isEdit = ref(false); // 是否编辑
    const form = reactive({
        userName: "",
        department: "",
        loginName: "",
        registerTime: "",
    });
    const loading = ref(false);

    // 获取用户信息
    async function getUser() {
        const { data } = await apiCommonInfo();
        form.userName = data?.userName || "";
        form.department = data?.department || "";
        form.loginName = data?.loginName || "";
        form.registerTime = data?.registerTime || "";
    }

    // 提交验证
    function handleSave() {
        const { userName, department } = form;
        // 验证用户名
        if (!userName) {
            ElMessage.error("请输入用户名");
            return;
        }
        if (!isChineseLetterNumber(userName)) {
            ElMessage.error("用户名不能包含特殊字符");
            return;
        }
        // 验证部门
        // if (!department) {
        //     ElMessage.error("请输入部门");
        //     return;
        // }
        if (department && !isChineseLetterNumber(department)) {
            ElMessage.error("部门不能包含特殊字符");
            return;
        }
        updateInfo();
    }

    // 保存请求
    async function updateInfo() {
        try {
            loading.value = true;
            const { code } = await apiCommonUpdateInfo(form);
            if (code !== "0") return;
            ElMessage.success("保存成功");
            isEdit.value = false;
        } catch {
            getUser();
        } finally {
            loading.value = false;
        }
    }

    getUser();

    return { isEdit, form, loading, handleSave };
};
